import { useSession } from "next-auth/react";
import Link from "next/link";
import { useState } from "react";
import { returnUtisci } from "../../../pages/api/utisak/getAll";
import Hero from "../../components/Hero/Hero";
import Pagination from "../../components/Pagination/Pagination";
import Utisak from "../Kompanija/components/Utisci/components/Utisak/Utisak";

interface UtisciType {
    recenzije: returnUtisci[];
}

export default function Utisci({ recenzije }: UtisciType) {
    const perPage = 12;
    const { data: session } = useSession();
    // const [filteredCompanies, setFilteredRecenzije] = useState(recenzije);
    const [activePage, setActivePage] = useState(1);

    const recenzijeZaPrikazati = recenzije?.slice(
        (activePage - 1) * perPage,
        perPage * activePage
    );

    return (
        <div className="relative bg-white">
            <Hero
                title="Recenzije"
                subtitle="Sve recenzije Dzobs.com portala poredane hronološki."
            />
            <section className="relative mb-20 max-w-screen-lg mx-auto p-6 bg-white">
                <div className="lg:px-0 w-full m-auto mb-8 ">
                    {recenzijeZaPrikazati?.map((utisak) => (
                        <Utisak
                            data={utisak}
                            key={utisak.createdAt}
                            companyId={1}
                            companyName={utisak.company.name}
                            isEditable={false} // {utisak.id === userUtisci?.utisakId}
                            isCompanyOwner={false}
                        />
                    ))}
                </div>
                {recenzije.length > 0 && (
                    <Pagination
                        total={recenzije.length}
                        activePage={activePage}
                        setActivePage={setActivePage}
                        perPage={perPage}
                    />
                )}
                {recenzije.length === 0 && (
                    <p className="text-center max-w-screen-sm m-auto mb-8 px-6 lg:px-0">
                        Recenzije možete vidjeti na profilima kompanija, ukoliko
                        želite da ih vidite ovdje na jednom mjestu poredane
                        hronološki, morate imati prethodno ostavljenu recenziju.
                        Neki vid nagrade ekipi koja nam je pomogla da skupimo
                        recenzije.
                    </p>
                )}
                <div className="text-center">
                    <Link href={`/ostavi-utisak`}>
                        <button
                            className="btn-primary rounded-md disabled:bg-gray-300"
                            type="button"
                        >
                            Ostavi recenziju
                        </button>
                    </Link>
                </div>
            </section>
        </div>
    );
}
